function getErrorPath(path) {
  return path.join(".");
}

export { getErrorPath };
//# sourceMappingURL=get-error-path.js.map
